export function app_version(state) {
	return state.login.app_version
}

export function attempts(state) {
	return state.attempts
}

export function background(state) {
	return state.login.background
}

export function clients(state) {
	return state.clients
}

export function colors(state) {
	return state.login.colors
}

export function default_language_id(state) {
	return state.login.default_language_id
}

export function full_background(state) {
	return state.login.full_background
}

export function languages(state) {
	return state.languages.map((l) => {
		const code_array = l.code.split('-')
		const uppercase = code_array[1].toUpperCase()
		return {
			...l,
			code: `${code_array[0]}-${uppercase}`,
		}
	})
}

export function layout(state) {
	return state.layout
}

export function social_auth(state) {
	return state.social_auth
}

export function use_complete_register(state) {
	return state.use_complete_register
}

export function login_accept_document(state) {
	return state.login.accept_document
}

export function login_user_pre_register(state) {
	return state.login.user_pre_register
}

export function login_user_register(state) {
	return state.login.user_register
}

export function login_default_language_id(state) {
	return state.login.default_language_id
}

export function login_oauth2(state) {
	return state.login.oauth2
}

export function login_dark_text(state) {
	return state.login.login_dark_text
}

export function login_show_public_faq(state) {
	return state.login.show_public_faq
}

export function logo(state) {
	return state.login.logo
}

export function login(state) {
	return state.login
}

export function logo_pt(state) {
	return state.login.logo_pt
}

export function logo_en(state) {
	return state.login.logo_en
}

export function logo_es(state) {
	return state.login.logo_es
}

export function logo_fr(state) {
	return state.login.logo_fr
}

export function logo_mobile(state) {
	return state.login.logo_mobile
}

export function logo_mobile_pt(state) {
	return state.login.logo_mobile_pt
}

export function logo_mobile_en(state) {
	return state.login.logo_mobile_en
}

export function logo_mobile_es(state) {
	return state.login.logo_mobile_es
}

export function logo_mobile_fr(state) {
	return state.login.logo_mobile_fr
}

export function oauth2(state) {
	return state.login.oauth2
}

export function password_strong_level(state) {
	return state.register.password_strong_level
}

export function recaptcha(state) {
	return state.login.use_recaptcha
}

export function register(state) {
	return state.register
}

export function register_fields(state) {
	return state.register.fields ? state.register.fields : []
}

export function show_portfolio_statistics(state) {
	return state.login.show_portfolio_statistics
}

export function show_login_plataform_links(state) {
	return state.login.show_login_plataform_links
}

export function text(state) {
	return state.login.text
}

export function text_header(state) {
	return state.login.text_header
}

export function user_profile(state) {
	return state.user_profile
}

export function under_maintenance(state) {
	return state.login.under_maintenance
}

export function use_background(state) {
	return state.login.use_background
}

export function user_pre_register(state) {
	return state.login.user_pre_register
}

export function user_register(state) {
	return state.login.user_register
}

export function use_portfolio_page(state) {
	return state.login.use_portfolio_page
}

export function zendesk_help(state) {
	return state.login.use_zendesk_help
}

export function login_colors(state) {
	return state.login.colors
}

export function cookies_optional(state) {
	return state.login.cookies_optional
}

export function cookies_type(state) {
	return state.login.cookies_type
}

export function show_azure_login_btn(state) {
	return state.login.show_azure_login_btn
}

export function mobile_background(state) {
	return state.login.mobile_background
}

export function support_use(state) {
	return state.layout.support_use
}
